import { render } from "./CheckmarkSvg.vue?vue&type=template&id=4a2a3cd2&scoped=true"
import script from "./CheckmarkSvg.vue?vue&type=script&lang=ts"
export * from "./CheckmarkSvg.vue?vue&type=script&lang=ts"

import "./CheckmarkSvg.vue?vue&type=style&index=0&id=4a2a3cd2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a2a3cd2"

export default script